import { type SVGProps } from "react";

const IFoodIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Fork-and-plate style icon representing food delivery */}
    <circle cx="12" cy="12" r="9" />
    <path d="M8 7v4c0 1.1.9 2 2 2h0c1.1 0 2-.9 2-2V7" />
    <line x1="9" y1="7" x2="9" y2="10" />
    <line x1="11" y1="7" x2="11" y2="10" />
    <path d="M15 7v10" />
    <path d="M15 11c1.7 0 2-1.3 2-2.5S16.7 7 15 7" />
  </svg>
);

export default IFoodIcon;
